import { PaginatedResult, SalesManager, SalesChannel, ProductType, PaymentModel, Department, SalesLeague } from '../dto/model';

export interface SalesAgentsFilters {
  name?: string;
  salesChannels?: SalesChannel[];
  isDeleted?: boolean;
  salesLeagues?: SalesLeague[];
  departments?: Department[];
  productTypes?: ProductType[];
  paymentModels?: PaymentModel[];
  regions?: string;
}

const rootUrl = process.env.REACT_APP_API_ROOT_URL;

export const salesAgentsService = {
  async getSalesAgents(accessToken: string, page: number, pageSize: number, filters: SalesAgentsFilters = {}): Promise<PaginatedResult<SalesManager[]> | null> {
    try {
      const queryParams = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
      });

      if (filters.name && filters.name.trim()) {
        queryParams.append('name', filters.name.trim());
      }

      if (filters.salesChannels && filters.salesChannels.length > 0) {
        queryParams.append('salesChannels', filters.salesChannels.join(','));
      }

      if (filters.isDeleted !== undefined) {
        queryParams.append('isDeleted', filters.isDeleted.toString());
      }

      if (filters.salesLeagues && filters.salesLeagues.length > 0) {
        queryParams.append('salesLeagues', filters.salesLeagues.join(','));
      }

      if (filters.departments && filters.departments.length > 0) {
        queryParams.append('departments', filters.departments.join(','));
      }

      if (filters.productTypes && filters.productTypes.length > 0) {
        queryParams.append('productTypes', filters.productTypes.join(','));
      }

      if (filters.paymentModels && filters.paymentModels.length > 0) {
        queryParams.append('paymentModels', filters.paymentModels.join(','));
      }

      if (filters.regions && typeof filters.regions === 'string' && filters.regions.trim()) {
        queryParams.append('regions', filters.regions.trim());
      }

      const url = `${rootUrl}/api/v1/sales-agents/search?${queryParams.toString()}`;
      const response = await fetch(url, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${accessToken}`,
        }),
      });
      if (!response.ok) {
        return null;
      }
      const data = await response.json();
      return data;
    } catch (error) {
      alert(`Failed to get sales agents. Exception while loading ${error}`);
    }
    return null;
  },
};
